import RecruitmentBanner from "./recruitment-banner";
import RecruitmentInfo from "./recruitment-info";

const Recruitment = () => {
    return (
        <>
            <RecruitmentBanner />
            <RecruitmentInfo />
        </>
    );
};

export default Recruitment;